module.exports = __webpack_public_path__ + "img/Hamsun_Spraak_og_fortellermaate_i_Pan.57fd6eac.jpg";